<template>
  <div class="form" :gutter="32">
    <el-form
      ref="form"
      :model="formModel"
      label-width="auto"
      label-position="top"
      :size="xs ? 'middle' : 'large'"
      :show-message="false"
    >
      <!-- 年度 -->
      <el-form-item label="年度" required prop="year">
        <el-select
          v-model="formModel.year"
          class="inherit-w"
          placeholder="Select"
          @change="handleYearChange"
        >
          <el-option
            placeholder="请选择年份"
            v-for="item in yearOptions.year"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <!-- 省市 -->
      <el-form-item label="省市">
        <el-select
          v-model="formModel.area"
          placeholder="Select"
          class="inherit-w"
          @change="changeProvince"
        >
          <el-option
            v-for="item in AREA_OPTIONS"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </el-form-item>
      <!-- 名称 -->
      <el-form-item
        :label="`${props.type === 'college' ? '医学院校' : '医院'}名称`"
      >
        <!-- <el-select
          v-model="formModel.name"
          filterable
          remote
          reserve-keyword
          :placeholder="`请输入${
            props.type === 'college' ? '医学院校' : '医院'
          }名称`"
          :remote-method="searchName"
          :loading="remoteSearchLoading"
          class="inherit-w"
          clearable
        >
          <el-option
            v-for="item in nameList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
        <el-autocomplete
          class="inherit-w"
          :placeholder="`请输入${
            props.type === 'college' ? '医学院校' : '医院'
          }名称`"
          v-model="formModel.name"
          :fetch-suggestions="searchName"
          @select="handleSelect"
          clearable
        />
      </el-form-item>
      <!-- 学科 -->
      <el-form-item label="学科" v-if="fields.includes('subject')">
        <el-cascader
          v-model="formModel.subject"
          :options="SUBJECT_OPTIONS"
          @change="handleChange"
          class="inherit-w"
          placeholder="请选择学科"
        />
      </el-form-item>
    </el-form>
    <el-row class="mt-3" :gutter="16">
      <el-col :xs="12" :sm="24" class="mb-4">
        <el-button
          class="inherit-w"
          @click="reset"
          :size="xs ? 'middle' : 'large'"
          >重置</el-button
        >
      </el-col>
      <el-col :xs="12" :sm="24" class="mb-4">
        <el-button
          :size="xs ? 'middle' : 'large'"
          type="warning"
          :icon="Search"
          class="inherit-w bg-active-color gradient-btn scale"
          @click="onSearch"
          >检 索</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  defineExpose,
  watch,
  toRaw
} from 'vue'
import { Search } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

import { searchHospital, searchCollege } from '@/api/config.js'
import Cache from '@/utils/cache.js'

import useSize from '@/hooks/useSize.js'

import { AREA_OPTIONS, DEFAULT_SUBJECT } from '../../constant.js'

const emits = defineEmits(['on-search', 'change-year', 'reset'])

const props = defineProps({
  fields: {
    type: Array,
    default: () => ['area', 'name', 'year']
  },
  type: {
    type: String,
    default: ''
  },
  area: {
    type: String,
    default: ''
  },
  yearOptions: {
    type: Object
  }
})
const { xs } = useSize()
//表单
const formModel = reactive({
  area: '全国',
  name: '',
  year: toRaw(props.yearOptions.current) + '',
  subject: []
})

//名称列表
const remoteSearchLoading = ref(false)
const nameList = ref([])

const SUBJECT_OPTIONS = Cache.get('top100_subject')

watch(
  () => props.area,
  (nVal) => {
    formModel.area = nVal
  }
)

//重置
const reset = () => {
  formModel.area = '全国'
  formModel.name = ''
  formModel.year = toRaw(props.yearOptions.current) + ''
  formModel.subject = props.fields.includes('subject') ? DEFAULT_SUBJECT : []
  nameList.value = []
  emits('reset', toRaw(formModel))
}

//检索
const onSearch = () => {
  const params = toRaw(formModel)
  // if (props.fields.includes('subject')) params.subject = toRaw(params.subject)
  emits('on-search', {
    ...params
  })
}
//重置名称
const resetName = () => {
  formModel.name = ''
  nameList.value = []
}

//改变年份
const handleYearChange = (value) => {
  resetName()
}

const changeProvince = (value) => {
  resetName()
}

//检索名称
const searchName = async (keyword, cb) => {
  const { area, year, subject } = formModel
  if (!area || !year) {
    return ElMessage.warning(`请先选择省市和年份`)
  }
  if (keyword) {
    remoteSearchLoading.value = true
    const query = {
      name: keyword,
      province: area,
      year: year
    }
    if (subject && subject.length) query.code = subject[1]
    const result =
      props.type === 'college'
        ? await searchCollege(query).catch((_) => {
            nameList.value = []
          })
        : await searchHospital(query).catch((_) => {
            nameList.value = []
          })
    remoteSearchLoading.value = false
    nameList.value = result.map((item) => ({ label: item, value: item }))
  } else {
    nameList.value = []
  }
  cb(nameList.value)
}
const handleSelect = ({ value }) => {
  formModel.name = value
}
defineExpose({
  reset,
  formModel
})
</script>

<style lang="scss" scoped>
.form {
  ::v-deep {
    .el-form-item {
      &__content {
        width: 100%;
      }
      &__label {
        color: #333;
        font-weight: 600;
        font-size: 1rem;
      }
    }
  }
}
</style>
